module.exports = __webpack_public_path__ + "static/media/on-internacional.f18c544a.png";